export type ParsedAdEntityDetails = {
  nodeId: string;
  entityKind: string;
  displayName: string;
  objectId: string;
  isCrownJewel: boolean;
  samAccountName?: string;
  distinguishedName?: string;
  properties?: string;
};

export function parseAdEntityDetailsOutput(
  output: string,
): ParsedAdEntityDetails | null {
  const lines = output.split('\n');
  const fields = new Map<string, string>();

  for (const line of lines) {
    const colonIndex = line.indexOf(':');
    if (colonIndex <= 0) {
      continue;
    }
    const key = line.slice(0, colonIndex).trim();
    const value = line.slice(colonIndex + 1).trim();
    fields.set(key, value);
  }

  const nodeId = fields.get('Node ID');
  const entityKind = fields.get('Kind');
  const displayName = fields.get('Display name');
  const objectId = fields.get('Object ID');

  if (!nodeId || !entityKind || !displayName || !objectId) {
    return null;
  }

  return {
    nodeId,
    entityKind,
    displayName,
    objectId,
    isCrownJewel: fields.get('Crown jewel') === 'true',
    samAccountName: fields.get('SAM account'),
    distinguishedName: fields.get('DN'),
    properties: fields.get('Properties'),
  };
}
